module.exports = __webpack_public_path__ + "static/media/neumaticos.7ccca1bc.png";